import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { newsletterService } from "../services/newsletterService";

export const NewsletterUnsubscribe = () => {
  const [searchParams] = useSearchParams();
  const { t } = useTranslation();
  const [status, setStatus] = useState("loading");
  const token = searchParams.get("token");

  useEffect(() => {
    if (!token) {
      setStatus("error");
      return;
    }

    newsletterService.unsubscribe(token).then((result) => {
      setStatus(result.success ? "success" : "error");
    });
  }, [token]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="max-w-md w-full bg-white p-8 rounded-lg shadow-sm">
        {status === "loading" && (
          <p className="text-center text-gray-600">{t("newsletterUnsubscribe.loading")}</p>
        )}
        {status === "success" && (
          <>
            <h1 className="text-2xl font-bold mb-4">{t("newsletterUnsubscribe.successTitle")}</h1>
            <p className="text-gray-600">{t("newsletterUnsubscribe.successDescription")}</p>
          </>
        )}
        {status === "error" && (
          <>
            <h1 className="text-2xl font-bold mb-4 text-red-600">{t("newsletterUnsubscribe.errorTitle")}</h1>
            <p className="text-gray-600">{t("newsletterUnsubscribe.errorDescription")}</p>
          </>
        )}
      </div>
    </div>
  );
};
